import { Button } from '~ui/base/button';
import { Typography } from '~ui/base/typography';
import { cn } from '~lib/utils/style';

interface DatasetsErrorProps {
  error: Error;
  onRetry: () => void;
}

function DatasetsError({ error, onRetry }: DatasetsErrorProps) {
  return (
    <div
      className={cn(
        'rounded-[1.25rem] border border-destructive/30',
        'bg-destructive-container p-8 text-destructive-container-foreground',
      )}
    >
      <Typography variant="headline-sm" as="h2">
        Couldn&apos;t load datasets
      </Typography>
      <Typography variant="body-md" as="p" className="mt-3">
        {error.message}
      </Typography>
      <Typography
        variant="caption-md"
        as="p"
        className="mt-2 text-destructive-container-foreground/80"
      >
        If this persists, check that you have <span className="font-mono">Storage
        Blob Data Reader</span> on the storage account and that CORS is
        configured for this origin.
      </Typography>
      <Button variant="secondary" size="md" className="mt-5" onClick={onRetry}>
        Try again
      </Button>
    </div>
  );
}

export { DatasetsError };
